import { createSimpleContext } from "./helper";
export const {
  use: usePromptRef,
  provider: PromptRefProvider
} = createSimpleContext({
  name: "PromptRef",
  init: () => {
    let current;
    return {
      get current() {
        return current;
      },
      set(ref) {
        current = ref;
      }
    };
  }
});